import React, { Fragment } from "react";
import { connect } from "react-redux";
import { logOut } from "auth/authActions";

import MenuItem from "@mui/material/MenuItem";
import Typography from "@mui/material/Typography";

import UserProfileSwitchOrgsMenu from "./UserProfileSwitchOrgsMenu";

const UserProfileMenu = props => {
  const { onDropDownClose, onLogout, onClose } = props;

  return (
    <Fragment>
      <UserProfileSwitchOrgsMenu
        closeDropDown={onDropDownClose}
        onClose={onClose}
      />

      {/* <MenuItem className={classes.menuItem}>
        <Typography className={classes.text}>My Profile</Typography>
      </MenuItem> */}

      <MenuItem onClick={onLogout}>
        <Typography>Sign Out</Typography>
      </MenuItem>
    </Fragment>
  );
};

const mapDispatchToProps = dispatch => ({
  onLogout: () => {
    dispatch(logOut());
  },
});

export default connect(null, mapDispatchToProps)(UserProfileMenu);
